import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from '../errors/api-error'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_FAX')

const headers = {
  'Content-Type': 'application/json',
}

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export type FaxShowImages = 'ask' | 'always' | 'never'

export interface IFaxSettings {
  fax_settings_id?: string
  clinic_id?: string
  add_clinic_logo: boolean
  show_unread: boolean
  notify_on_new_fax: boolean
  notify_on_failed_delivery: boolean
  resend_failed_fax: boolean
  retention_period: number
  retention_period_unit: string
  max_pages: number | null
  show_images: FaxShowImages
  updated_by?: string | null
}

type FaxSettingsResponseData = { fax_settings?: IFaxSettings }

const getHeaders = (dbName?: string): Record<string, string> =>
  dbName ? { ...headers, 'x-db-name': dbName } : headers

export const getFaxSettings = async (
  dbName?: string,
): Promise<ApiResponse<FaxSettingsResponseData>> => {
  try {
    const response = await axios.get<ApiResponse<FaxSettingsResponseData>>(
      `${BUSINESS_LAYER_API}/api/v1/fax/settings`,
      { headers: getHeaders(dbName) },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in getFaxSettings:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const updateFaxSettings = async (
  data: Partial<IFaxSettings>,
  dbName?: string,
): Promise<ApiResponse<FaxSettingsResponseData>> => {
  try {
    const response = await axios.put<ApiResponse<FaxSettingsResponseData>>(
      `${BUSINESS_LAYER_API}/api/v1/fax/settings`,
      data,
      { headers: getHeaders(dbName) },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in updateFaxSettings:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}
